import React from 'react';
import { Whatsapp } from 'react-bootstrap-icons';
import './WhatsApp.css';

const WhatsAppIcon = () => (
  <a
    href="https://wa.me/+919784889134"
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-fab"
    aria-label="Chat with us on WhatsApp"
  >
    <Whatsapp size={26} aria-hidden="true" />
  </a>
);

export default WhatsAppIcon;
